export default function PuzzleNumberPad({
  symbols = [],
  counts = {},
  selectedCellLabel = 'No cell selected',
  selectedValue = null,
  selectedHasNotes = false,
  selectionLocked = false,
  onSelectSymbol,
  onClear,
}) {
  const selectionReady = Boolean(selectedCellLabel) && !selectionLocked;
  const clearDisabled = !selectionReady || (selectedValue === null && !selectedHasNotes);

  return (
    <section className="space-y-3 rounded-[1.25rem] border border-slate-200 bg-slate-50 p-3 sm:p-4">
      <div className="space-y-1">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400">
          Number pad
        </p>
        <p className="text-sm leading-5 text-slate-600">
          {selectionReady
            ? `Selected: ${selectedCellLabel}`
            : selectionLocked
              ? `${selectedCellLabel} is a given clue and cannot be edited.`
              : 'Select an open cell, then tap a number.'}
        </p>
      </div>

      <div className="grid grid-cols-5 gap-2 lg:grid-cols-2">
        {symbols.map((symbol) => {
          const isActive = selectedValue !== null && String(selectedValue) === symbol.key;
          const fillCount = counts[symbol.key] || 0;

          return (
            <button
              key={symbol.key}
              type="button"
              disabled={!selectionReady}
              onClick={() => onSelectSymbol(symbol.value)}
              className={`aspect-square rounded-[1rem] border px-1 py-2 text-center transition ${
                isActive
                  ? 'border-brand-cyan bg-cyan-50 text-slate-900'
                  : 'border-slate-200 bg-white text-slate-800 hover:border-brand-cyan hover:bg-cyan-50'
              } disabled:cursor-not-allowed disabled:opacity-50`}
            >
              <span className="block text-lg font-semibold leading-none sm:text-xl">
                {symbol.label}
              </span>
              <span className="mt-1 block text-[10px] font-medium uppercase tracking-[0.16em] text-slate-400">
                {fillCount}/9
              </span>
            </button>
          );
        })}
        <button
          type="button"
          onClick={onClear}
          disabled={clearDisabled}
          className="aspect-square rounded-[1rem] border border-rose-200 bg-white px-1 py-2 text-center text-rose-600 transition hover:bg-rose-50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <span className="block text-sm font-semibold leading-none sm:text-base">Clear</span>
          <span className="mt-1 block text-[10px] font-medium uppercase tracking-[0.16em] text-rose-300">
            Cell
          </span>
        </button>
      </div>
    </section>
  );
}
